import { render } from "./OutboundCampaign.vue?vue&type=template&id=680115e9&scoped=true"
import script from "./OutboundCampaign.vue?vue&type=script&lang=js"
export * from "./OutboundCampaign.vue?vue&type=script&lang=js"

import "./OutboundCampaign.vue?vue&type=style&index=0&id=680115e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680115e9"]])

export default __exports__